<template>
  <div class="report-page">
    <div class="header-banner">
      <div class="header-content">
        <p class="company-name">{{ companyName }}</p>
        <h1 class="main-title">商户经营周报</h1>
        <div class="date-selector" @click="showDatePicker = true">
          {{ dateRange }}
        </div>
      </div>
      <img src="@/assets/image/chongdian.png" class="header-illus" />
    </div>

    <div class="card overview-card">
      <div class="card-header">
        <span class="title">经营概览 <small>{{ stationCount }}站 | {{ gunCount }}枪</small></span>
        <span class="desc">指标说明 <i class="el-icon-question"></i></span>
      </div>
      <div class="stats-grid">
        <div class="stat-item">
          <p class="label">充电量 (度)</p>
          <p class="value">{{ formatNum(statsData.consumePower) }}</p>
          <p class="trend" :class="statsData.powerTrend >= 0 ? 'up' : 'down'">
            {{ statsData.powerTrend >= 0 ? '▲' : '▼' }} {{ Math.abs(statsData.powerTrend || 0) }}%
          </p>
        </div>
        <div class="stat-item">
          <p class="label">充电服务费 (元)</p>
          <p class="value">{{ formatNum(statsData.serviceFee) }}</p>
          <p class="trend" :class="statsData.feeTrend >= 0 ? 'up' : 'down'">
            {{ statsData.feeTrend >= 0 ? '▲' : '▼' }} {{ Math.abs(statsData.feeTrend || 0) }}%
          </p>
        </div>
        <div class="stat-item">
          <p class="label">枪日均充电量 (度)</p>
          <p class="value">{{ formatNum(statsData.avgPowerPerGun) }}</p>
          <p class="trend" :class="statsData.powerTrend >= 0 ? 'up' : 'down'">
            {{ statsData.powerTrend >= 0 ? '▲' : '▼' }} {{ Math.abs(statsData.powerTrend || 0) }}%
          </p>
        </div>
        <div class="stat-item">
          <p class="label">枪日均服务费 (元)</p>
          <p class="value">{{ formatNum(statsData.avgFeePerGun) }}</p>
          <p class="trend" :class="statsData.feeTrend >= 0 ? 'up' : 'down'">
            {{ statsData.feeTrend >= 0 ? '▲' : '▼' }} {{ Math.abs(statsData.feeTrend || 0) }}%
          </p>
        </div>
      </div>
    </div>

    <div class="card summary-card">
      <div class="card-header">
        <span class="title">本周小结</span>
      </div>
      <div class="summary-content">
        <span class="tag">整体情况</span>
        <p class="summary-text">{{ summaryText }}</p>
      </div>
    </div>

    <div class="section-container">
      <div class="section-title">
        <span>波动聚焦</span>
        <small>异常波动场站或充电枪</small>
      </div>

      <div class="card table-card">
        <div class="card-header">
          <span class="title">波动场站 TOP5 <i class="el-icon-question"></i></span>
          <span class="more">全部 <i class="el-icon-arrow-right"></i></span>
        </div>
        <div class="table-header">
          <span>场站名称</span>
          <span>枪日均充电量</span>
          <span>环比上期</span>
        </div>
        <div class="table-body" v-if="stationFluctuation.length > 0">
          <div class="table-row" v-for="(item, index) in stationFluctuation" :key="index">
            <span class="cell-name">{{ item.name }}</span>
            <span class="cell-val">{{ formatNum(item.avgPower) }}</span>
            <span class="cell-trend" :class="item.trend >= 0 ? 'up' : 'down'">
              {{ item.trend >= 0 ? '▲' : '▼' }} {{ Math.abs(item.trend) }}%
            </span>
          </div>
        </div>
        <div class="empty-holder" v-else>
          <img src="https://img.icons8.com/ios/100/999999/box--v1.png" class="empty-img" />
          <p>本周无异常波动场站</p>
        </div>
      </div>

      <div class="card table-card">
        <div class="card-header">
          <span class="title">低效枪 TOP5 <i class="el-icon-question"></i></span>
          <span class="more">全部 <i class="el-icon-arrow-right"></i></span>
        </div>
        <div class="table-header">
          <span>枪ID</span>
          <span>日均充电量</span>
          <span>同站快枪日均充电量</span>
        </div>
        <div class="table-body" v-if="lowEfficiencyGuns.length > 0">
          <div class="table-row" v-for="(item, index) in lowEfficiencyGuns" :key="index">
            <span class="cell-name">{{ item.gunId }}</span>
            <span class="cell-val">{{ formatNum(item.avgPower) }}</span>
            <span class="cell-val secondary">{{ formatNum(item.stationAvgPower) }}</span>
          </div>
        </div>
        <div class="empty-holder" v-else>
          <img src="https://img.icons8.com/ios/100/999999/box--v1.png" class="empty-img" />
          <p>本周无低效枪</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getManageTotalData, getPileStatiscsList, agentPlotList } from "@/api/newApi";

export default {
  name: 'WeeklyReport',
  data() {
    return {
      showDatePicker: false,
      companyName: '商户',
      dateRange: '',
      stationCount: 0,
      gunCount: 0,
      statsData: {
        consumePower: 0,
        serviceFee: 0,
        avgPowerPerGun: 0,
        avgFeePerGun: 0,
        powerTrend: 0,
        feeTrend: 0
      },
      summaryText: '暂无数据',
      stationFluctuation: [],
      lowEfficiencyGuns: []
    };
  },
  mounted() {
    this.getReportData();
  },
  methods: {
    async getReportData() {
      try {
        const [manageRes, pileRes, stationRes] = await Promise.all([
          getManageTotalData({}),
          getPileStatiscsList({}),
          agentPlotList({})
        ]);

        if (stationRes.data && stationRes.data.length > 0) {
          this.stationCount = stationRes.data.length;
          this.companyName = stationRes.data[0].merchantName || '商户';
        }

        if (pileRes.data && pileRes.data.length > 0) {
          this.gunCount = pileRes.data.length;
        }

        if (manageRes.data) {
          const data = manageRes.data;
          this.statsData.consumePower = data.consumePower || 0;
          this.statsData.serviceFee = data.serviceFee || 0;
          
          const totalGuns = this.gunCount || 1;
          this.statsData.avgPowerPerGun = (this.statsData.consumePower / totalGuns).toFixed(2);
          this.statsData.avgFeePerGun = (this.statsData.serviceFee / totalGuns).toFixed(2);
          
          this.generateSummary();
        }
      } catch (err) {
        console.log('获取周报数据失败', err);
      }
    },
    generateSummary() {
      const trend = this.statsData.powerTrend;
      const trendText = trend >= 0 ? `+${trend}%` : `-${Math.abs(trend)}%`;
      this.summaryText = `本周充电量 ${trendText}，整体运营${trend >= 0 ? '良好' : '有所下降'}。`;
    },
    refresh() {
      this.getReportData();
    },
    formatNum(num) {
      if (num === null || num === undefined) return '0';
      const n = parseFloat(num);
      if (isNaN(n)) return '0';
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped>
.report-page {
  background-color: #F0F6FF;
  min-height: 100vh;
  padding-bottom: 30px;
}

.header-banner {
  background: linear-gradient(180deg, #D6E8FF 0%, #F0F6FF 100%);
  height: 240px;
  position: relative;
  padding: 15px 20px;
  overflow: hidden;

  .nav-icons {
    display: flex;
    justify-content: space-between;
    i { font-size: 22px; color: #333; cursor: pointer; }
  }

  .header-content {
    margin-top: 25px;
    .company-name { font-size: 14px; color: #666; line-height: 1.4; }
    .main-title { font-size: 28px; font-weight: 800; color: #1A1A1A; margin: 10px 0; }
    .date-selector {
      display: inline-block;
      background: rgba(255, 255, 255, 0.6);
      padding: 4px 12px;
      border-radius: 15px;
      font-size: 13px;
      color: #333;
      cursor: pointer;
    }
  }

  .header-illus {
    position: absolute;
    right: -10px;
    bottom: 20px;
    width: 140px;
    opacity: 0.9;
  }
}

.card {
  background: #FFF;
  margin: 0 16px 15px;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(100, 150, 200, 0.05);

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .title {
      font-size: 17px;
      font-weight: bold;
      color: #333;
      small { font-weight: normal; color: #999; font-size: 12px; margin-left: 8px; }
    }
    .desc, .more { font-size: 12px; color: #BBB; cursor: pointer; i { font-size: 14px; } }
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  .stat-item {
    .label { font-size: 13px; color: #999; margin-bottom: 5px; }
    .value { font-size: 20px; font-weight: bold; color: #1A1A1A; }
    .trend { font-size: 12px; margin-top: 4px; &.down { color: #52C41A; } &.up { color: #F5222D; } }
  }
}

.summary-card {
  .summary-content {
    .tag {
      display: inline-block;
      background: #E6F7FF;
      color: #1890FF;
      font-size: 11px;
      padding: 2px 6px;
      border-radius: 4px;
      margin-bottom: 10px;
    }
    .summary-text {
      font-size: 14px;
      color: #444;
      line-height: 1.6;
      .down-text { color: #52C41A; }
      .station-link { color: #00BFA5; margin-left: 4px; }
      &::before { content: "•"; color: #CCC; margin-right: 8px; }
    }
  }
}

.section-container {
  .section-title {
    padding: 10px 20px;
    span { font-size: 18px; font-weight: bold; }
    small { color: #999; margin-left: 10px; font-size: 12px; }
  }
}

.table-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  color: #BBB;
  font-size: 11px;
  border-bottom: 1px solid #F5F5F5;
  span { flex: 1; text-align: center; &:first-child { text-align: left; } &:last-child { text-align: right; } }
}

.table-body {
  .table-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #F5F5F5;
    &:last-child { border-bottom: none; }
    .cell-name { flex: 1; font-size: 13px; color: #333; text-align: left; }
    .cell-val { flex: 1; text-align: center; font-size: 13px; color: #333; &.secondary { color: #999; font-size: 12px; } }
    .cell-trend { flex: 1; text-align: right; font-size: 12px; &.up { color: #F5222D; } &.down { color: #52C41A; } }
  }
}

.empty-holder {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-img { width: 50px; opacity: 0.2; margin-bottom: 10px; }
  p { font-size: 13px; color: #BBB; }
}
</style>